import { BaseOption } from '../base-option';

export class AddCharacteristicModalPayload {
  resourceName: string;
  resourceId: number;
  activeTab: BaseOption;
  type: number;
}
